module.exports = __webpack_public_path__ + "media/images/xpass/icons/handshake-f916d6664b418bc17022899829a0ea27.svg";